import React, { Fragment } from 'react';
import MenuItem from "@material-ui/core/MenuItem";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
    maxWidth: 500,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  Button: {
    marginRight: theme.spacing(1),
  }
}));

const BranchNavigationButton = ({ text, orgInfo, branchesList }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  let history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleRedirect = (id, moduleName) => {
    try {
      setAnchorEl(null);
      var orgName = orgInfo.orgName;

      for (var i = 0; i < branchesList.length; i++) {
        if (moduleName === branchesList[i]) {
          history.push('/orgs/' + orgName + '/branches/' + moduleName);
          break;
        }
      }
    } catch (e) {
    }
  };

  var menuItems = {};

  try {
    // Branch menu items
    for (var i = 0; i < branchesList.length; i++) {
      menuItems[i] = branchesList[i];
    }
  } catch (e) {
    // console.log(e);
  }

  return (
    <Fragment>
      <Button className={classes.Button} variant="outlined" color="primary" onClick={handleClick}>
        {text}
      </Button>
      <Menu
        id="navigation-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleRedirect} >
        {Object.entries(menuItems).map(([key, value]) =>
          <MenuItem key={key} value={value} onClick={() => handleRedirect(key, value)}>
            {value}
          </MenuItem>
        )}
      </Menu>
    </Fragment>
  );
};

export default BranchNavigationButton;